import { Placement, PlacementArea, Text, Flex } from '@bitrise/bitkit';
import { useReferenceElement, SeriesPointXY } from '@bitrise/bitviz';
import { TypeMetricUnit } from '@trace/types';
import React, { FunctionComponent } from 'react';
import getFormattedMetricValue from '../../../../utils/metric/getFormattedValue';

interface Props {
  avg: null | number;
  color: string;
  max: null | number;
  min: null | number;
  point: null | SeriesPointXY;
  visible: boolean;
  unit: TypeMetricUnit;
}

const MinMaxTooltip: FunctionComponent<Props> = (props) => {
  const { avg, color, max, min, point, visible, unit } = props;
  const referenceElement = useReferenceElement(point);

  if (!referenceElement) {
    return null;
  }

  return (
    <Placement
      backgroundColor="black"
      borderRadius="x1"
      minWidth="8rem"
      placement="top"
      referenceElement={referenceElement}
      style={{ pointerEvents: 'none' }}
      textColor="gray-1"
      visible={visible}
    >
      {() => (
        <PlacementArea padding="x3" withArrow>
          <Text align="middle" config="8">
            <Text textColor="gray-5">Average</Text>
            <Text>{getFormattedMetricValue(unit, avg)}</Text>
          </Text>

          <Flex
            alignChildrenVertical="middle"
            direction="horizontal"
            margin="x4"
            paddingHorizontal="x6"
          >
            <Flex backgroundColor="white" container grow height="1px">
              <Flex Component="svg" absolute="center" height="16px" width="16px">
                <polygon fill={color} points="0,-8 8,0 0,8 -8,0" transform="translate(8, 8)" />
              </Flex>
            </Flex>
          </Flex>

          <Flex direction="horizontal" gap="x3">
            <Flex grow>
              <Text align="middle" config="8">
                <Text textColor="gray-5">Minimum</Text>
                <Text>{getFormattedMetricValue(unit, min)}</Text>
              </Text>
            </Flex>

            <Flex grow>
              <Text align="middle" config="8">
                <Text textColor="gray-5">Maximum</Text>
                <Text>{getFormattedMetricValue(unit, max)}</Text>
              </Text>
            </Flex>
          </Flex>
        </PlacementArea>
      )}
    </Placement>
  );
};

export default MinMaxTooltip;
